import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const StyledButton = styled.button `
    transition: all 0.2s ease-in-out;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 15px;
    cursor: pointer;
    background-color: transparent;
    margin-left: 25px;
    z-index: 6;

    @media only screen and (min-width: 1400px) {
        display: none;
    }

    &:hover,
    &:focus {
        outline: none;
    }
`;
const IconWrapper = styled.div `
    position: absolute;
    width: 22px;
    height: 16px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media only screen and (min-width: 768px) {
        width: 24px;
        height: 18px;
    }
`;
const Span = styled.span `
    display: block;
    position: absolute;
    height: 2px;
    width: 21px;
    background: ${props => props.theme.primary.base};
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
        top: 0;

        ${props => props.toggleIcon &&
    css `
                top: 7px;
                transform: rotate(135deg);
            `};
    }

    &:nth-child(2) {
        top: 7px;

        ${props => props.toggleIcon &&
    css `
                opacity: 0;
                pointer-events: none;
            `};
    }

    &:nth-child(3) {
        top: 14px;

        ${props => props.toggleIcon &&
    css `
                top: 7px;
                transform: rotate(-135deg);
            `};
    }
`;
const MenuToggle = ({ toggleIcon, ...props }) => (_jsx(StyledButton, { toggleIcon: toggleIcon, ...props, children: _jsxs(IconWrapper, { children: [_jsx(Span, { toggleIcon: toggleIcon }), _jsx(Span, { toggleIcon: toggleIcon }), _jsx(Span, { toggleIcon: toggleIcon })] }) }));
export default MenuToggle;
